// extracted by mini-css-extract-plugin
export default {"buttonCenter":"styles_buttonCenter__UOq5f","fullView":"styles_fullView__f7vVz","shimmer":"styles_shimmer__CmeEH"};